import { createContext, useContext, useState, useCallback, ReactNode } from "react";
import React from "react";

export type AppMode = "player" | "manager";

const STORAGE_KEY = "app-mode";

interface AppModeContextType {
  mode: AppMode | null;
  setMode: (m: AppMode) => void;
  clearMode: () => void;
}

const AppModeContext = createContext<AppModeContextType>({
  mode: null,
  setMode: () => {},
  clearMode: () => {},
});

export function AppModeProvider({ children }: { children: ReactNode }) {
  const [mode, setModeState] = useState<AppMode | null>(() => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(STORAGE_KEY) as AppMode | null;
  });

  const setMode = useCallback((m: AppMode) => {
    setModeState(m);
    localStorage.setItem(STORAGE_KEY, m);
  }, []);

  const clearMode = useCallback(() => {
    setModeState(null);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return React.createElement(AppModeContext.Provider, { value: { mode, setMode, clearMode } }, children);
}

export function useAppMode() {
  return useContext(AppModeContext);
}
